(function () {
  'use strict';

  // Two seconds was fine when a gallery held three or four images. Product galleries now
  // mirror the App Store listing - eleven slides on Bundle - and at that pace it read as a
  // flicker rather than a slideshow, with no slide on screen long enough to take in.
  var INTERVAL_MS = 5000;

  function initRotator(rotatorEl) {
    if (rotatorEl.getAttribute('data-initialized') === 'true') return;

    var slides = rotatorEl.querySelectorAll('.agency-hero__slide');
    if (slides.length < 2) return;

    if (rotatorEl._rotatorIntervalId) {
      clearInterval(rotatorEl._rotatorIntervalId);
      rotatorEl._rotatorIntervalId = null;
    }
    rotatorEl.setAttribute('data-initialized', 'true');

    var dots = rotatorEl.querySelectorAll('.agency-hero__dot');
    var currentIndex = 0;

    function showSlide(index) {
      currentIndex = index;
      if (currentIndex >= slides.length) currentIndex = 0;
      if (currentIndex < 0) currentIndex = slides.length - 1;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        stopInterval();
        showSlide(idx);
        // startInterval declines on a video slide, so choosing the video parks there.
        startInterval();
      });
    });

    function isVideoSlide(index) {
      var slide = slides[index];
      return !!(slide && slide.querySelector('[data-hero-video], .agency-hero__video-frame'));
    }

    function next() {
      // Auto-advance never lands on the video. It is the slide most worth watching, so it
      // is reached deliberately - by its dot - not by a timer that would move off it again
      // a few seconds later.
      var index = currentIndex;
      for (var step = 0; step < slides.length; step++) {
        index = (index + 1) % slides.length;
        if (!isVideoSlide(index)) break;
      }
      showSlide(index);
    }

    // Set once a video starts playing. Guarding inside startInterval rather than
    // swapping the function out matters: the mouseleave listener below holds a direct
    // reference, so a replacement would not be seen by it.
    var stopped = false;

    function startInterval() {
      if (stopped) return;
      // Sitting on the video means the visitor is looking at it, or about to click it.
      if (isVideoSlide(currentIndex)) return;
      if (rotatorEl._rotatorIntervalId) return;
      rotatorEl._rotatorIntervalId = setInterval(next, INTERVAL_MS);
    }

    function stopInterval() {
      if (rotatorEl._rotatorIntervalId) {
        clearInterval(rotatorEl._rotatorIntervalId);
        rotatorEl._rotatorIntervalId = null;
      }
    }

    rotatorEl.addEventListener('mouseenter', stopInterval);
    rotatorEl.addEventListener('mouseleave', startInterval);

    // Video slides render as a poster button; clicking swaps in the embed and ends
    // rotation, because advancing off a playing video every two seconds would be absurd.
    rotatorEl.querySelectorAll('[data-hero-video]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-hero-video');
        if (!id) return;

        var host = button.getAttribute('data-hero-video-host') || 'youtube';
        var src =
          host === 'vimeo'
            ? 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1'
            : 'https://www.youtube.com/embed/' + encodeURIComponent(id) +
              '?autoplay=1&rel=0&modestbranding=1';

        var frame = document.createElement('iframe');
        frame.src = src;
        frame.className = 'agency-hero__video-frame';
        frame.setAttribute('frameborder', '0');
        frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        frame.setAttribute('allowfullscreen', 'allowfullscreen');
        frame.setAttribute('title', button.getAttribute('aria-label') || 'Video');

        button.replaceWith(frame);
        stopped = true;
        stopInterval();
      });
    });

    startInterval();
  }

  function initAll() {
    var rotators = document.querySelectorAll('[data-hero-rotator]');
    rotators.forEach(function (el) {
      el.removeAttribute('data-initialized');
      initRotator(el);
    });
  }

  function initSection(sectionEl) {
    var rotator = sectionEl ? sectionEl.querySelector('[data-hero-rotator]') : null;
    if (rotator) {
      rotator.removeAttribute('data-initialized');
      initRotator(rotator);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.detail && e.detail.sectionId;
      var sectionEl = section ? document.getElementById('agency-home-hero-' + section) : null;
      if (sectionEl) {
        initSection(sectionEl);
      } else {
        initAll();
      }
    });
  }
})();
